import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";
import { FilterState } from "../reducers/filter.reducer";
import * as moment from "moment";

export const serviceApi = {
    
    getPlotSeasonSummaryData: (plotId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetPlotSeasonSummaryData();

        request.product = process.env.PRODUCT;
        request.plotId = plotId;

        const promise = client.get(request);
        return Observable.from(promise);
    },

    getPlotSummaryData: (plotIds: number[], classifications: DTOS.Classification[], plotEventDateStart: any, plotEventDateEnd: any) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetPlotSummaryData();

        request.plotIds = plotIds;
        request.classificationIds = classifications ? classifications.map(c => c.id) : undefined;
        request.plotEventCreatedDateStart = plotEventDateStart ? plotEventDateStart.toJSON() : undefined;
        request.plotEventCreatedDateEnd = plotEventDateEnd ? plotEventDateEnd.toJSON() : undefined;

        const promise = client.get(request);
        return Observable.from(promise);
    },

    getUserPlotEventSummaryData: () => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetPlatypusUserPlotEventsSummaryData();

        request.product = process.env.PRODUCT;

        const promise = client.get(request);
        return Observable.from(promise);
    },

    getPlotEvents: (plotId: number, userId: number, limit: number, createdDateStart, createdDateEnd) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetPlotEvents();

        /*request.product = process.env.PRODUCT;
        request.plotIds = plotIds;*/

        request.plotId = plotId;
        request.limit = limit;
        request.userId = userId;
        request.eventDateStart = createdDateStart ? createdDateStart.toJSON() : undefined;
        request.eventDateEnd = createdDateEnd ? createdDateEnd.toJSON() : undefined;

        const promise = client.get(request);
        return Observable.from(promise);
    },

    getPlots: (createdDateStart: any, createdDateEnd: any, plotEventDateStart: any, plotEventDateEnd: any, plotStatusCodesToInclude: string[]) => {
        var client = new JsonServiceClient("");
        var getPlotsRequest = new DTOS.GetPlots();

        getPlotsRequest.createdDateStart = createdDateStart ? createdDateStart.toJSON() : undefined;
        getPlotsRequest.createdDateEnd = createdDateEnd ? createdDateEnd.toJSON() : undefined;
        getPlotsRequest.plotEventStartedDateStart = plotEventDateStart ? plotEventDateStart.toJSON() : undefined;
        getPlotsRequest.plotEventStartedDateEnd = plotEventDateEnd ? plotEventDateEnd.toJSON() : undefined;

        getPlotsRequest.product = process.env.PRODUCT;
        getPlotsRequest.plotStatusCodesToInclude = plotStatusCodesToInclude;

        const promise = client.get(getPlotsRequest);
        return Observable.from(promise);
    },

    getSinglePlot: (plotId: number) => {
        var client = new JsonServiceClient("");
        var getPlotRequest = new DTOS.GetSinglePlot();

        getPlotRequest.plotId = plotId;

        const promise = client.get(getPlotRequest);
        return Observable.from(promise);
    },

    getSummaryDataByClassification: (classificationTypes: string[], questionCode: string, plotId?: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetSummaryDataByClassification();
        request.product = process.env.PRODUCT;
        request.plotId = plotId;
        request.classificationTypes = classificationTypes;
        request.questionCode = questionCode;
        const promise = client.get(request);
        return Observable.from(promise);
    },

    getUserPlots: (includePlotEvents: boolean, specificUserId?: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetUserPlots();
        request.product = process.env.PRODUCT;
        request.includePlotEvents = includePlotEvents;
        request.userId = specificUserId;
        const promise = client.get(request);
        return Observable.from(promise);
    },

    search: (searchFilter: FilterState) => {
        var client = new JsonServiceClient("");
        var searchRequest = new DTOS.Search();
        if (searchFilter !== undefined) {
            searchRequest.startDate = searchFilter.startDate;
            searchRequest.endDate = searchFilter.endDate;
            //searchRequest.classifications = searchFilter.selectedClassifications ? searchFilter.selectedClassifications.concat(searchFilter.selectedTypes) : undefined;
            searchRequest.groups = searchFilter.selectedGroups;
            searchRequest.questions = searchFilter.selectedQuestions;
            searchRequest.regions = searchFilter.selectedRegion;
        }
        searchRequest.product = process.env.PRODUCT;
        const promise = client.put(searchRequest);
        return Observable.from(promise);
    },
};
